import Vue from 'vue'
import Vuex from 'vuex'
import { jsonp } from '@/libs/network.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: false,
    isIphone: false,
    listIndex: 1, //列表页-当前分页脚标
    navBarFixed: false,
    navList: []
  },
  mutations: {
    setplatform (state) {
      state.isMobile = true;
    },
    setiphone (state) {
      state.isIphone = true;
    },
    setListIndex (state, index) {
      state.listIndex = index;
    },
    setNavList (state, list) {
      state.navList = list;
    },
    setBarFixed (state, s) {
      state.navBarFixed = s;
    }
  },
  actions: {
    setNavList (context) {
      jsonp('/navList', {
        'callback': 'nav'
      }).then(res => {
        context.commit('setNavList', res.data);
      }, err => {
        console.log(err);
      });
    }
  }
})
